export default "__VITE_ASSET__d57dcd6b__"